<template>
  <div class="textbox-wrapper"
    :title="title"
    :class="{ 'inline': inline, 'disabled': disabled, 'error': invalid == true || (required === true && !hasValue) }">
    <slot name="content-left"></slot>
    <div v-if="hasPrefix" class="prefix" :style="prefixStyle">{{prefix}}</div>
    <div v-if="hasPrefix && showSeparator" class="separator-line"></div>
    <input
      :type="type"
      :pattern="pattern"
      :required="required"
      :readonly="readonly"
      :id="id"
      :class="{'empty': !hasValue}"
      :placeholder="placeholder"
      v-model="currentValue"
      :disabled="disabled"
      :minlength="minLength"
      :maxlength="maxLength"
      @change="handleChange"
      @input="onInput"
    />
    <div title="Очистить поле" v-if="!disabled && showClearIcon && currentValue && currentValue.length" @click="clearValue" class="clear-icon"></div>
    <slot name="content-right"><span class="no-content-right"></span></slot>
  </div>
</template>

<script>
export default {
  // Отключаем автоматическое наследование атрибутов корневым div-ом
  inheritAttrs: false, 
  name: 'TextBox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    prefix: {
      type: String,
      default: ''
    },
    noWrapPrefix: {
      type: Boolean,
      default: false
    },
    prefixColor: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null,
    },
    showSeparator: {
      type: Boolean,
      default: false
    },
    showClearIcon: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: null
    },
    minLength: {
      type: [String, Number],
      default: null
    },
    maxLength: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      id: null
    }
  },
  computed: {
    hasPrefix() {
      return this.prefix && this.prefix != '';
    },
    hasValue() {
      return this.value && this.value.toString().length;
    },
    currentValue: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit('change', value);
      }
    },
    prefixStyle() {
      if (this.prefixColor && this.prefixColor != '') {
        return `color: ${this.prefixColor}!important;` + `'white-space': ${this.noWrapPrefix ? 'nowrap' : 'break-spaces'}`;
      }
      else {
        return `white-space: ${this.noWrapPrefix ? 'nowrap' : 'break-spaces'}`;
      }
    },
  },
  methods: {
    onInput(event) {
      this.$emit('input', this.currentValue);
      this.handleChange(event);
    },
    handleChange(event) {
      const inputEl = event.target;
      
      // Браузер сам проверяет input на основе pattern, required, minlength, maxlength
      // inputEl.validity.valid возвращает true или false
      const isValid = inputEl.validity.valid === true;

      // Генерируем событие validation для родителя и передаем статус валидности
      // console.log('text-box.handleChange, emit change.isValid:' + isValid);
      this.$emit('validation', isValid);
    },
    clearValue() {
      this.currentValue = null;
      // this.$emit('input', this.currentValue);
    }
  },
  mounted () {
    this.id = `textbox_${this._uid}`
  }
}
</script>
<style scoped>
.textbox-wrapper:focus-within {
  border-color: highlight;
}
.textbox-wrapper.disabled {
  color: var(--textColorDisabled);
}
.textbox-wrapper.error {
  border-color: red!important;
}
.textbox-wrapper .prefix {
  text-align: right;
  margin: 3px 7px 3px 0;
}
.textbox-wrapper.inline {
  margin-bottom: 5px;
}
.textbox-wrapper .separator-line {
  align-self: normal;
  border-right: 1px solid var(--hr-color);
  width: 1px;
  background: none;
  box-shadow: inset 1px 1px 1px 1px #00000045;
  display: inline-flex;
  margin: 3px 7px 3px 0;
}

/* .textbox-wrapper:has(input[type="email"]:invalid) {
  border-color: red!important;
} */

 .textbox-wrapper:has(input:invalid) {
  border-color: red!important;
}

.textbox-wrapper input[type="password"],
.textbox-wrapper input[type="email"],
.textbox-wrapper input[type="number"],
.textbox-wrapper input[type="text"],
.textbox-wrapper input[type="url"],
.textbox-wrapper input[type="time"],
.textbox-wrapper input[type="date"] {
  /* width: auto; */
  width: 100%;
}

.textbox-wrapper input[type="number"] {
  /* width: auto; */
  width: calc(100% - 3em);
}

.textbox-wrapper input[type="password"],
.textbox-wrapper input[type="email"],
.textbox-wrapper input[type="number"],
.textbox-wrapper input[type="text"],
.textbox-wrapper input[type="url"],
.textbox-wrapper input[type="time"] {
  font: inherit;
  margin-bottom: 0;
  margin-right: auto;
  background: inherit;
  color: var(--textColor);
  border: none;
  border-radius: 0;
  outline: none;
  color-scheme: dark;
  align-self: flex-start;
  padding: 3px 0;
  background: none;
}
.textbox-wrapper input[type="text"]:disabled,
.textbox-wrapper input[type="email"]:disabled,
.textbox-wrapper input[type="url"]:disabled,
.textbox-wrapper input[type="time"]:disabled,
.textbox-wrapper input[type="date"].empty {
  color: var(--textColorDisabled);
}
.textbox-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  font: inherit;
  height: 100%;
  padding: 0 10px;
  width: calc(100% - 22px);
  max-width: calc(100% - 22px);
  background: var(--input-box-background);
  border-radius: var(--ui-control-border-radius);
  border: 1px solid var(--border-color);
  margin-bottom: 1rem;
}
.textbox-wrapper .clear-icon {
  cursor: pointer;
  margin-top: 0.1em;
}
.no-content-right {
  margin-right: -10px;
}
.textbox-wrapper .clear-icon::after {
  content: "✖";
  color: var(--textColorDisabled);
  margin-right: 10px;
}
</style>